import { Link } from "react-router-dom";
import { NerdStackFooter } from "../components/NerdStackFooter.jsx";
import BackArrow from "../components/BackArrow.jsx";
import { gradientFor } from "../components/toolGradients.js";
import { ToolPageBadge } from "../components/ToolPageBadge.jsx";

// NerdPhys accent = true cyan #22B8F0, per the LOCKED icon-derived rule
// (in-app accent = icon gradient START hue; Ph mark = true-cyan -> violet,
// cyan NOT blue — this is the exact hue from the locked icon spec).
export const PHYS_ACCENT = "#22B8F0";
export const VIOLET = "#7C3AED";

export function PhysShell({ title, children, back = "/phys" }) {
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#0A0B14",
        color: "#E8E9F3",
        display: "flex",
        flexDirection: "column",
        paddingTop: "env(safe-area-inset-top)",
        paddingBottom: "env(safe-area-inset-bottom)",
      }}
    >
      <header
        style={{
          display: "flex",
          alignItems: "center",
          gap: 12,
          padding: "16px 18px",
          borderBottom: "1px solid #1C1E2E",
          position: "sticky",
          top: 0,
          background: "#0A0B14",
          zIndex: 10,
        }}
      >
        <BackArrow to={back} from={PHYS_ACCENT} toColor={gradientFor(title, "/phys/x").from} />
        <ToolPageBadge name={title} family="phys" accent={PHYS_ACCENT} />
        <h1 style={{ fontSize: 17, fontWeight: 600, margin: 0 }}>{title}</h1>
      </header>
      <main style={{ flex: 1, padding: "clamp(20px, 3vw, 36px) clamp(18px, 4vw, 40px)", maxWidth: "min(900px, 92vw)", width: "100%", margin: "0 auto" }}>
        {children}
      </main>
      <footer style={{ padding: "14px 18px", borderTop: "1px solid #1C1E2E" }}>
        <NerdStackFooter variant="tool" family="phys" />
      </footer>
    </div>
  );
}

export function Field({ label, suffix, ...props }) {
  return (
    <label style={{ display: "block", marginBottom: 14 }}>
      <span style={{ fontSize: 13, color: "#9A9DBE", display: "block", marginBottom: 6 }}>{label}</span>
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <input
          {...props}
          inputMode="decimal"
          style={{ flex: 1, background: "#13141F", border: "1px solid #262839", borderRadius: 10, color: "#E8E9F3", fontSize: 16, padding: "12px 14px", outline: "none", boxSizing: "border-box", width: "100%" }}
        />
        {suffix && <span style={{ fontSize: 14, color: "#5B5E7A", minWidth: 36 }}>{suffix}</span>}
      </div>
    </label>
  );
}

export function ResultCard({ children }) {
  return (
    <div style={{ marginTop: 18, background: "#13141F", border: `1px solid ${PHYS_ACCENT}33`, borderRadius: 12, padding: "16px 18px" }}>
      {children}
    </div>
  );
}

export function Stat({ label, value, unit }) {
  return (
    <div style={{ display: "flex", justifyContent: "space-between", padding: "8px 0", borderBottom: "1px solid #1C1E2E" }}>
      <span style={{ color: "#9A9DBE", fontSize: 14 }}>{label}</span>
      <span style={{ color: PHYS_ACCENT, fontWeight: 700, fontSize: 15 }}>{value} <span style={{ color: "#5B5E7A", fontWeight: 400 }}>{unit}</span></span>
    </div>
  );
}

export const primaryBtn = {
  width: "100%",
  background: PHYS_ACCENT,
  color: "#02232E",
  fontWeight: 700,
  fontSize: 16,
  border: "none",
  borderRadius: 12,
  padding: "14px 0",
  cursor: "pointer",
  marginTop: 4,
};

